module.exports = __webpack_public_path__ + "static/media/mujer-hombre1.2e703751.jpg";